module.exports = __webpack_public_path__ + "static/media/settings.73bf6687.svg";